import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Value = /*#__PURE__*/function () {
  function Value(value) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Value);
    this.value = value;
    this.params = params;
    if (typeof value === 'undefined') this.value = params.value;
  }
  _createClass(Value, [{
    key: "setValue",
    value: function setValue(value) {
      this.value = value;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      // значение по умолчанию можно не подставлять, оно будет забито самим react-ом
      // что не всегда действительно, значение по умолчанию для базовых типов (вроде string "")
      return this.value === this.params.value ? undefined : this.value;
    }
  }, {
    key: "accept",
    value: function accept() {}
  }]);
  return Value;
}();